// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../helpers/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `​ .wiki-content .actionItem a,
.wiki-content .actionItem a:link,
.wiki-content .actionItem a:visited,
.wiki-content .actionItem a:hover,
.fabric-comment .actionItem a,
.fabric-comment .actionItem a:link,
.fabric-comment .actionItem a:visited,
.fabric-comment .actionItem a:hover {
	color: var(--ds-text-subtlest, --color-medium-grey);
	cursor: pointer;
}
​ .wiki-content .actionItem a:hover,
.fabric-comment .actionItem a:hover {
	text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/Comment/CommentActions.css"],"names":[],"mappings":"AACA;;;;;;;;CAQC,mDAAmD;CACnD,eAAe;AAChB;AACA;;CAEC,0BAA0B;AAC3B","sourcesContent":["@import '../../helpers/variables.css';\n​ .wiki-content .actionItem a,\n.wiki-content .actionItem a:link,\n.wiki-content .actionItem a:visited,\n.wiki-content .actionItem a:hover,\n.fabric-comment .actionItem a,\n.fabric-comment .actionItem a:link,\n.fabric-comment .actionItem a:visited,\n.fabric-comment .actionItem a:hover {\n\tcolor: var(--ds-text-subtlest, --color-medium-grey);\n\tcursor: pointer;\n}\n​ .wiki-content .actionItem a:hover,\n.fabric-comment .actionItem a:hover {\n\ttext-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
